<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-data-table
          :headers="headers"
          :items="items"
          class="purple-header-table"
          item-key="device_id"
          hide-actions
          expand
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td width="25%">{{ props.item.device_id }}</td>
              <td width="25%" @click="props.expanded = !props.expanded">
                {{ props.item.date[0] }}
                <v-btn icon v-if="props.item.date.length > 1" :class="{ expanded: props.expanded }">
                  <v-icon icon color="purple">expand_more</v-icon>
                </v-btn>
              </td>
              <td width="15%" @click="props.expanded = !props.expanded">{{ props.item.amount[0] }}</td>
              <td width="25%" @click="props.expanded = !props.expanded">{{ props.item.status[0] }}</td>
              <td width="10%">
                <v-btn icon small color="purple" dark flat>
                  <v-icon>info</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template slot="expand" slot-scope="props">
            <table class="axpand-table">
              <tr v-for="(amount, index) in (props.item.amount.length - 1)" :key="index">
                <td width="25%"></td>
                <td width="25%">{{ props.item.date[index + 1] }}</td>
                <td width="15%">{{ props.item.amount[index + 1] }}</td>
                <td width="25%">{{ props.item.status[index + 1] }}</td>
                <td width="10%"></td>
              </tr>
            </table>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  name: "transactions",
  data: () => ({
    expand: false,
    headers: [
      {
        text: "DEVICE ID",
        align: "left",
        value: "device_id"
      },
      { text: "DATE", value: "date" },
      { text: "AMOUNT", value: "amount" },
      { text: "STATUS", value: "status" },
      { text: "", value: "info" }
    ],
    items: [
      {
        device_id: "ID",
        date: [
          "date",
          "date",
          "date",
          "date",
          "date"
        ],
        amount: ["amount", "amount", "amount", "amount", "amount"],
        status: ["status", "status", "status", "status", "status"]
      }
    ]
  }),

  created() {
    this.init();
  },

  methods: {
    init() {
      axios
        .get(this.$hostname + "/client/user_transactions", {
          headers: {
            Authorization: localStorage.getItem("token")
          }
        })
        .then(response => {
          console.log(response);
          this.items = response.data.details.map(item => {
            return {
              device_id: item.device_id,
              date: [...item.data].map(element => {
                return element.updated_date.split(' ')[0]
              }),
              amount: [...item.data].map(element => {
                return 'US $' + Math.round(element.amount * 100) / 10000
              }),
              status: [...item.data].map(element => {
                return element.status
              }),
            }
          });
          console.log(this.items);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.axpand-table {
  width: 100%;
  border-collapse: collapse;
  tr {
    border-bottom: none !important;
  }
}
.v-btn.expanded {
  .v-icon {
    transform: rotate(180deg);
  }
}
</style>
